import {useIsSoftFeatureToggleActive} from '@aboutyou/feature-flags';
import Page from '@aboutyou/legacy-desktop/src/app/pages/LiveShopping/LiveShopping';
import redialHandle from '@aboutyou/legacy-desktop/src/app/pages/LiveShopping/redial';
import React from 'react';
import redial from 'redial';
import {NotFound} from '../../app/components/pages/NotFoundPage/NotFound';
import {withLegacyProviders} from '../LegacyComponentWrapper';

const PageWithRedial = redial.provideHooks(redialHandle)(Page);

const LiveShoppingPageWithLegacyProviders = withLegacyProviders(PageWithRedial);

export const LiveShoppingPage: React.FC<React.PropsWithChildren> = props => {
  return useIsSoftFeatureToggleActive('disable_drops_entry') ? (
    <NotFound />
  ) : (
    <LiveShoppingPageWithLegacyProviders {...props} />
  );
};
